import { Button, Dropdown, Layout, Menu, Modal, PageHeader, Table, Tabs, Typography } from 'antd';
import { EllipsisOutlined, ExclamationCircleOutlined, FieldTimeOutlined, ReloadOutlined } from '@ant-design/icons';
import TerminalScreen from '../../../elements/terminal-screen';
import React, { useEffect, useState } from 'react';
import { apiClient, apiErrorMessage } from '../../../utils';

export function LogsPage() {
  const { Content } = Layout;
  const { Text } = Typography;
  const [loading, setLoading] = useState(false);
  const [logs, setLogs] = useState<any[]>([]);
  const [currentLog, setCurrentLog] = useState<string>('');
  const [isModalVisible, setIsModalVisible] = useState(false);

  useEffect(() => {
    loadLogs();
  }, []);

  const loadLogs = () => {
    setLoading(true);
    apiClient
      .get('log-history')
      .then(response => {
        setLogs(response.data);
        setLoading(false);
      })
      .catch((reason: any) => {
        setLoading(false);
        apiErrorMessage(reason);
      });
    setLoading(false);
  };

  const tableActions = (id: string) => (
    <Menu onClick={(e: any) => onGridActionClick(e, id)}>
      <Menu.Item key="show">
        <Text>Görüntüle</Text>
      </Menu.Item>
      <Menu.Item key="download">
        <Text>İndir</Text>
      </Menu.Item>
      <Menu.Item key="del">
        <Text type="danger">Sil</Text>
      </Menu.Item>
    </Menu>
  );

  const onGridActionClick = (e: any, id: string) => {
    if (e.key === 'del') {
      confirmDeleteLog(id);
    } else if (e.key === 'show') {
      openLogShowModal(id);
    } else if (e.key === 'download') {
      window.open(apiClient.defaults.baseURL + `log-history/download-log/${id}`, '_blank');
    }
  };

  const confirmDeleteLog = (id: string) => {
    const onOk = () => deleteLog(id);
    Modal.confirm({
      title: 'Log dosyası sil',
      icon: <ExclamationCircleOutlined />,
      content: 'Log dosyasını silmek istediğinize emin misiniz?',
      okText: 'Evet',
      cancelText: 'Vazgeç',
      onOk: onOk,
    });
  };

  const deleteLog = (id: string) => {
    setLoading(true);
    apiClient
      .delete(`log-history/${id}`)
      .then(() => {
        setLoading(false);
        loadLogs();
      })
      .catch((reason: any) => {
        setLoading(false);
        apiErrorMessage(reason);
      });
  };

  const openLogShowModal = (id: string) => {
    setCurrentLog(id);
    setIsModalVisible(true);
  };

  const terminalModal = () => {
    return (
      <Modal
        title={'Log dosyası: ' + currentLog}
        width={1200}
        visible={isModalVisible}
        onCancel={() => {
          setIsModalVisible(false);
          setCurrentLog('');
        }}
        footer={null}
        destroyOnClose
      >
        <TerminalScreen source={'log-history/tail-log/' + currentLog} />
      </Modal>
    );
  };

  const columns = [
    {
      title: 'Log dosyası',
      dataIndex: 'name',
      key: 'name',
      render: (text: any, record: any) => (
        <span style={{ cursor: 'pointer', color: '#1890ff' }} onClick={() => openLogShowModal(text)}>
          {text}
        </span>
      ),
    },
    {
      title: 'Boyut',
      dataIndex: 'size',
      key: 'size',
      render: (text: any) => <Text>{Math.ceil(text / 1024 / 1024)} MB</Text>,
    },
    {
      key: 'actions',
      render: (text: any, record: any) => (
        <div style={{ textAlign: 'right' }}>
          <Dropdown overlay={tableActions(record.name)} trigger={['click']}>
            <Button size="small" icon={<EllipsisOutlined />} />
          </Dropdown>
        </div>
      ),
    },
  ];

  return (
    <>
      <PageHeader
        title={
          <>
            <FieldTimeOutlined /> Sistem log'ları
          </>
        }
      />
      <Content>
        <Tabs destroyInactiveTabPane>
          <Tabs.TabPane tab="Güncel log" key="current_logs">
            <TerminalScreen source={'log-history/tail-log/latest'} setIsModalVisible={setIsModalVisible} />
          </Tabs.TabPane>
          <Tabs.TabPane tab="Tüm log dosyaları" key="user">
            <div style={{ textAlign: 'right', marginBottom: '1rem' }}>
              <Button key="refresh" onClick={loadLogs} icon={<ReloadOutlined />}>
                Yenile
              </Button>
            </div>
            <Table dataSource={logs} columns={columns} loading={loading} rowKey={row => row?.name} />
          </Tabs.TabPane>
        </Tabs>
        {terminalModal()}
      </Content>
    </>
  );
}
